export default __webpack_public_path__ + "static/media/000.65070bf8.jpg";